import Breadcrumb from 'components/Common/Breadcrumb2';
import { convertToDateOnly, formatDateTimeToAmPm } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import axiosInstance from 'pages/Utility/axiosInstance';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams, } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import { Container, Row, Col, Card, CardBody, Button, Table, ListGroup, ListGroupItem, Modal, ModalHeader, ModalFooter, ModalBody, FormGroup, Label, Input } from 'reactstrap';
import InsertExtensionModal from './InsertExtend';
import { showSuccess } from 'helpers/notification_helper';
import { FaCodeBranch, FaHashtag, FaStar, FaUser, FaUserCircle } from 'react-icons/fa';
import { SlCalender } from "react-icons/sl";
import { RiTeamLine } from "react-icons/ri";
import { IoCopyOutline, IoTicketOutline } from "react-icons/io5";
import MarkAsComplete from './MarkAsComplete';
import LOGO_IMG from '../../assets/images/logo-dark.png';
import { LiaComment } from "react-icons/lia";
import * as Yup from 'yup';
import Select from 'react-select';
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import { AiOutlineSolution } from 'react-icons/ai';
import { LuSquareUserRound } from 'react-icons/lu';

const WorkOrderDetails = () => {

  const [workOrderDetails, setWorkOrderDetails] = useState();
  const [addresses, setAddresses] = useState();
  const [customerProfile, setCustomerProfile] = useState();
  const [workOrderItems, setWorkOrderItems] = useState();
  const [isExtend, setIsExtend] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [showStartModal, setShowStartModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [checklistModal, setChecklistModal] = useState(false);
  const [showMarkAsCompleteModal, setShowMarkAsCompletedModal] = useState(false);
  const [statusList, setStatusList] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [submittedStatus, setSubmittedStatus] = useState();
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [reason, setReason] = useState();
  const [showPendingConfirmationModal, setShowPendingConfirmationModal] = useState(false);
  const [hover, setHover] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [startReason, setStartReason] = useState('');
  const [completeReason, setCompleteReason] = useState('');
  const [images, setImages] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remarkError, setRemakError] = useState();
  const [cancelReasonError, setCancelReasonError] = useState()
  const [completeRemarkError, setCompleteRemarkError] = useState()
  const { id } = useParams()
  const navigate = useNavigate();
  const location = useLocation();
  const printRef = useRef();
  const [confirmation, setConfirmation] = useState(false);
  const [reasonsList, setReasonsList] = useState([]);
  const [selectedReasonOption, setSelectedReasonOption] = useState(null);
  const [showGenericModal, setShowGenericModal] = useState(false);
  const [showGenericConfirmationModal, setShowGenericConfirmationModal] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [isReasonsLoading, setIsReasonsLoading] = useState(false);

  const permissions2 = JSON.parse(localStorage?.getItem('permissions') || '[]');
  const userString = Cookies.get('authUser');
  const user = userString ? JSON.parse(userString) : null;
  const userId = user?.userId;
  if (!permissions2?.map(item => item?.permissionName)?.includes("Work Order Details") && !permissions2?.map(item => item?.permissionName)?.includes("Add Work Orders") && !permissions2?.map(item => item?.permissionName)?.includes("Edit Work Orders") && !permissions2?.map(item => item?.permissionName)?.includes("Feedback Link") && !permissions2?.map(item => item?.permissionName)?.includes("Mark As Completed") && !permissions2?.map(item => item?.permissionName)?.includes("Work Order Extension")) {
    navigate('/pages-403')
  }


  const fetchWorkOrderDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('', { params: { sp: "usp_GetWorkorderProfile", WorkOrderId: id } })
      setWorkOrderDetails(response?.data?.Data?.[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const fetchStatusList = async () => {
    try {
      setIsStatusLoading(true);
      const response = await axiosInstance.get('', { params: { sp: "usp_GetWorkorderStatus", workorderId: id, userId: userId } })
      if (response) {
        setStatusList(response?.data?.Data);
      }
      setIsStatusLoading(false);
    } catch (error) {
      console.log(error);
      setIsStatusLoading(false);
    }
  }

  const fetchStatusReasons = async (statusCategory) => {
    try {
      setIsReasonsLoading(true);
      const response = await axiosInstance.get('', {
        params: {
          sp: "usp_GetWorkOrderStatusReasons",
          StatusCategory: statusCategory
        }
      });
      if (response && response.data && response.data.Data) {
        setReasonsList(response.data.Data.map(r => ({
          value: r.ReasonText,
          label: r.ReasonText
        })));
      } else {
        setReasonsList([]);
      }
      setIsReasonsLoading(false);
    } catch (error) {
      console.error(error);
      setReasonsList([]);
      setIsReasonsLoading(false);
    }
  }

  useEffect(() => {
    if (loading) return;
    fetchWorkOrderDetails()
    if (user?.userRole !== "Sales agent") {
      fetchStatusList();
    }
  }, [])

  useEffect(() => {
    if (submittedStatus) {
      setSelectedReasonOption(null);
      setCancelReason('');
      setStartReason('');
      setCompleteReason('');
      setReason('');
      fetchStatusReasons(submittedStatus);
      if (submittedStatus === "WorkOrderCompleted") {
        setIsOpen(true)
      } else if (submittedStatus === "WorkOrderPending" || submittedStatus === "SignalIssue"
        || submittedStatus === "Unreachable" || submittedStatus === "CustomerUnreachable"
        || submittedStatus === "PreparingNetwork" || submittedStatus === "SIMCardIssue"
        || submittedStatus === "WorkOrderRescheduled" || submittedStatus === "WorkOrderScheduled"
      ) {
        setShowPendingModal(true);
      }
      else if (submittedStatus === "WorkOrderStarted") {
        setShowStartModal(true);
      } else if (submittedStatus === "WorkOrderCancelled") {
        setShowCancelModal(true)
      }
    }
  }, [submittedStatus])

  useEffect(() => {
    if (workOrderDetails?.customerAddresses) {
      setAddresses(JSON?.parse(workOrderDetails?.customerAddresses)?.[0])
      setWorkOrderItems(JSON?.parse(workOrderDetails?.WorkOrderItems))
      setCustomerProfile(JSON?.parse(workOrderDetails?.CustomerProfile)?.[0])
    }
  }, [workOrderDetails])

  const handleExtendClose = () => {
    setIsExtend(false);
  }

  const handleExtendSubmit = async (data, resetForm) => {
    try {
      const response = await axiosInstance.post('', {
        "sp": "usp_InsertWorkOrderExtensionHistory",
        "workOrderId": id,
        "requestedBy": userId,
        ...data
      })
      if (response) {
        fetchWorkOrderDetails()
        handleExtendClose()
        resetForm();
        if (user?.userRole === "Super Admin" || user?.userRole === "Supervisor") {
          showSuccess("Successfully Extended")
        } else {
          showSuccess("Extension request sent successfully")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleCancellation = async () => {
    try {
      const response = await axiosInstance.post('', {
        "sp": "usp_InsertWorkOrderCancellationHistory",
        "workOrderId": id,
        "requestedBy": userId,
        "reason": cancelReason || "",
      });
      if (response) {
        fetchWorkOrderDetails();
        fetchStatusList();
        setShowCancelModal(false);
        setCancelReason('');
        setSubmittedStatus("");
        setSelectedStatus("");
        if (user?.userRole === "Super Admin" || user?.userRole === "Supervisor") {
          showSuccess("Successfully Cancelled")
        } else {
          showSuccess("Cancellation request sent successfully")
        }
      }
    } catch (error) {
      setSubmittedStatus("");
      setShowCancelModal(false);
    }
  }

  const handleMarkAsCompleted = async () => {
    if (!completeReason?.trim()) {
      setCompleteRemarkError(true);
      return;
    }
    try {
      const response = await axiosInstance.post('', {
        sp: "usp_WorkOrderMarkAsCompleted",
        workOrderId: id,
        changedBy: userId,
        reason: completeReason || "",
        workOrderNewStatus: "WorkOrder Completed",
      });

      if (response) {
        setShowMarkAsCompletedModal(false);
        fetchWorkOrderDetails();
        fetchStatusList();
        showSuccess("Marked As Completed");
        setSubmittedStatus("");
        setSelectedStatus("");
        setCompleteReason('');
      }
    } catch (error) {
      setSubmittedStatus("");
      setShowMarkAsCompletedModal(false);
    }
  };

  const handleClose = () => {
    setSubmittedStatus("");
    // setSelectedStatus("")
    setIsOpen(false);
  }

  const handleSubmit = () => {
    setChecklistModal(true)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText('https://fonzcrm.intertoons.com' + workOrderDetails?.feedbackUrl)
      .then(() => {
        showSuccess("copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  useEffect(() => {
    if (workOrderDetails?.WorkOrderLocationImages) {
      setImages(JSON.parse(workOrderDetails?.WorkOrderLocationImages)?.map(item => ({ imagePath: item?.imagePath, imageEvent: item?.imageEvent })))
      setImagePreviews(JSON?.parse(workOrderDetails?.WorkOrderLocationImages)?.map(item => (`${process.env.REACT_APP_BASE_URL}` + item?.imagePath)));
    }
  }, [workOrderDetails?.WorkOrderLocationImages])

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    // Replace the body content with the content to print
    document.body.innerHTML = printContents;

    // Trigger the print
    window.print();

    // Restore the original content
    document.body.innerHTML = originalContents;
    window.location.reload(); // Refresh to restore React state
  };

  const handleChecklistConfirmation = async () => {
    setChecklistModal(false);
    setShowMarkAsCompletedModal(true);
  }

  const handleStartConfirmation = async () => {
    if (!startReason?.trim()) {
      setRemakError(true)
      return;
    }
    try {
      const response = await axiosInstance.post('', {
        sp: "usp_InsertWorkOrderStatus",
        workOrderId: id,
        changedBy: userId,
        workOrderNewStatus: "WorkOrder Started",
        reason: startReason || "",
      });

      if (response) {
        setShowStartModal(false);
        fetchWorkOrderDetails();
        fetchStatusList();
        showSuccess("Successfully started");
        setSubmittedStatus("");
        setSelectedStatus("");
        setStartReason('');
      }
    } catch (error) {
      console.log(error);
      setSubmittedStatus("");
      setShowStartModal(false);
    }
  };

  const handleCancelConfirmation = async () => {
    if (cancelReason?.trim()) {
      handleCancellation()
    } else {
      setCancelReasonError(true)
      return;
    }
  };

  const handleMarkAsCompletedConfirmation = () => {
    handleMarkAsCompleted();
  }

  const handlePendingConfirmationConfirmation = async () => {

    try {
      const response = await axiosInstance.post('',
        {
          "sp": "usp_InsertWorkOrderStatus",
          "workOrderId": id,
          "changedBy": userId,
          "workOrderNewStatus": selectedStatus?.label.split(" ").join("") ?? "WorkOrder Pending",
          "reason": reason
        });

      if (response) {
        setShowPendingConfirmationModal(false);
        fetchWorkOrderDetails();
        fetchStatusList();
        showSuccess("Successfully marked as Pending")
        setSubmittedStatus("");
        setSelectedStatus("");
        setReason("")
      }
    } catch (error) {
      console.log(error);
      setSubmittedStatus("");
      setReason("");
      setShowPendingConfirmationModal(false);
    }

  }

  const validationSchema = Yup.object({
    rating: Yup.number(),
    comment: Yup.string()
      .max(500, "Comment can't exceed 500 characters")
      .required("Please leave your feedback"),
  });

  const handleFeedBackSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosInstance.post("", {
        sp: "usp_InsertCustomerSatisfactionForm",
        workorderId: id,
        rating: values.rating,
        comment: values.comment,
      });
      if (response) {
        setShowCompleteModal(false);
        setShowMarkAsCompletedModal(true);
        resetForm();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePendingSubmit = async (values, { resetForm }) => {
    setReason(values?.reason);
    setShowPendingConfirmationModal(true);
    setShowPendingModal(false);
  }

  const handleGenericSubmit = async (values, { resetForm }) => {
    setReason(values?.reason);
    setShowGenericConfirmationModal(true);
    setShowGenericModal(false);
  }

  const handleGenericConfirmation = async () => {
    try {
      const response = await axiosInstance.post('',
        {
          "sp": "usp_InsertWorkOrderStatus",
          "workOrderId": id,
          "changedBy": userId,
          "workOrderNewStatus": selectedStatus?.value,
          "reason": reason
        });

      if (response) {
        setShowGenericConfirmationModal(false);
        fetchWorkOrderDetails();
        fetchStatusList();
        showSuccess(`Successfully marked as ${selectedStatus?.value}`)
        setSubmittedStatus("");
        setSelectedStatus("");
        setReason("")
      }
    } catch (error) {
      console.log(error);
      setSubmittedStatus("");
      setReason("");
      setShowGenericConfirmationModal(false);
    }

  }

  const validationSchema2 = Yup.object().shape({
    reason: Yup.string()
      .trim()
      .required("Reason is required")
  });

  return (
    <>
      <MarkAsComplete setChecklistModal={setChecklistModal} setIsOpen={setIsOpen} setConfirmation={setConfirmation} id={id} visible={isOpen} handleClose={handleClose} backdrop="static" />
      {/* Cancel Work Order Modal */}
      <Modal
        isOpen={showCancelModal}
        toggle={() => { setShowCancelModal(false); setSubmittedStatus(""); }}
        backdrop="static"
      >
        <ModalHeader toggle={() => { setShowCancelModal(false); setSubmittedStatus(""); }}>
          Confirm Cancel
        </ModalHeader>
        <ModalBody>
          <p>Are you sure you want to cancel this work order?</p>
          <FormGroup>
            <Label for="cancelReasonDropdown">Reason <span style={{ color: "red" }}>*</span></Label>
            <Select
              id="cancelReasonDropdown"
              options={[...reasonsList, { value: 'Other', label: 'Other' }]}
              value={selectedReasonOption}
              isLoading={isReasonsLoading}
              onChange={(option) => {
                setSelectedReasonOption(option);
                if (option.value !== 'Other') {
                  setCancelReason(option.value);
                } else {
                  setCancelReason('');
                }
              }}
              placeholder="Select a reason"
              className="mb-3"
            />
          </FormGroup>
          {selectedReasonOption?.value === 'Other' && (
            <FormGroup>
              <Label for="cancelReason">Remarks <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="textarea"
                id="cancelReason"
                name="cancelReason"
                placeholder="Enter reason for cancellation..."
                rows="3"
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
              />
              {cancelReasonError && <span style={{ color: "red" }}>Remarks is required</span>}
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShowCancelModal(false);
              setSubmittedStatus("");
              setCancelReason('');
            }}
          >
            No
          </Button>
          <Button
            color="danger"
            onClick={handleCancelConfirmation}
            disabled={!cancelReason.trim()}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showStartModal} toggle={() => { setShowStartModal(false); setSubmittedStatus(""); }} backdrop="static">
        <ModalHeader toggle={() => { setShowStartModal(false); setSubmittedStatus(""); }}>Confirm Start</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to start this work order?</p>
          <FormGroup>
            <Label for="startReasonDropdown">Reason <span style={{ color: "red" }}>*</span></Label>
            <Select
              id="startReasonDropdown"
              options={[...reasonsList, { value: 'Other', label: 'Other' }]}
              value={selectedReasonOption}
              isLoading={isReasonsLoading}
              onChange={(option) => {
                setSelectedReasonOption(option);
                if (option.value !== 'Other') {
                  setStartReason(option.value);
                } else {
                  setStartReason('');
                }
              }}
              placeholder="Select a reason"
              className="mb-3"
              required={true}
            />
          </FormGroup>
          {selectedReasonOption?.value === 'Other' && (
            <FormGroup>
              <Label for="startReason">Remarks <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="textarea"
                id="startReason"
                name="startReason"
                placeholder="Enter your reason (optional)..."
                rows="3"
                value={startReason}
                required={true}
                onChange={(e) => setStartReason(e.target.value)}
              />
              {remarkError && <span style={{ color: "red" }}>remark is required</span>}
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowStartModal(false); setSubmittedStatus(""); setStartReason(''); }}>No</Button>
          <Button color="danger" onClick={handleStartConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={checklistModal} toggle={() => { setChecklistModal(false); setSubmittedStatus("") }} backdrop="static">
        <ModalHeader toggle={() => { setChecklistModal(false); setSubmittedStatus(""); }}>Confirm Checklists</ModalHeader>
        <ModalBody>Are you sure you want to proceed?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setChecklistModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handleChecklistConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showMarkAsCompleteModal} toggle={() => { setShowMarkAsCompletedModal(false); setSubmittedStatus(""); }} backdrop="static">
        <ModalHeader toggle={() => { setShowMarkAsCompletedModal(false); setSubmittedStatus(""); }}>Confirm Mark As Completed</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to mark this work order as completed?</p>
          <FormGroup>
            <Label for="completeReasonDropdown">Reason <span style={{ color: "red" }}>*</span></Label>
            <Select
              id="completeReasonDropdown"
              options={[...reasonsList, { value: 'Other', label: 'Other' }]}
              value={selectedReasonOption}
              isLoading={isReasonsLoading}
              onChange={(option) => {
                setSelectedReasonOption(option);
                if (option.value !== 'Other') {
                  setCompleteReason(option.value);
                } else {
                  setCompleteReason('');
                }
              }}
              placeholder="Select a reason"
              className="mb-3"
            />
          </FormGroup>
          {selectedReasonOption?.value === 'Other' && (
            <FormGroup>
              <Label for="completeReason">Remarks <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="textarea"
                id="completeReason"
                name="completeReason"
                placeholder="Enter your reason (optional)..."
                rows="3"
                required
                value={completeReason}
                onChange={(e) => setCompleteReason(e.target.value)}
              />
              {completeRemarkError && <span style={{ color: "red" }}>Remarks is required</span>}
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowMarkAsCompletedModal(false); setSubmittedStatus(""); setCompleteReason(''); }}>No</Button>
          <Button color="danger" onClick={handleMarkAsCompletedConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showPendingConfirmationModal} toggle={() => { setShowPendingConfirmationModal(false); setSubmittedStatus("") }} backdrop="static">
        <ModalHeader toggle={() => { setShowPendingConfirmationModal(false); setSubmittedStatus("") }}>Confirm Pending</ModalHeader>
        <ModalBody>Are you sure you want to mark as Pending?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowPendingConfirmationModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handlePendingConfirmationConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      {/* modal for pending submit */}
      <Modal isOpen={showPendingModal} toggle={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }} centered backdrop="static">
        <ModalHeader toggle={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }}>Provide a Reason</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center">
            <Formik
              initialValues={{ reason: "", otherSelected: false }}
              validationSchema={validationSchema2}
              onSubmit={handlePendingSubmit}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <FormikForm
                  className="px-4 mx-3 bg-white"
                  style={{ minWidth: "300px", width: "600px", maxWidth: "500px" }}
                >
                  {/* Reason Selection Dropdown */}
                  <FormGroup>
                    <Label for="reasonDropdown">Reason <span style={{ color: "red" }}>*</span></Label>
                    <Select
                      id="reasonDropdown"
                      options={[...reasonsList, { value: 'Other', label: 'Other' }]}
                      isLoading={isReasonsLoading}
                      onChange={(option) => {
                        setFieldValue("otherSelected", option.value === 'Other');
                        if (option.value !== 'Other') {
                          setFieldValue("reason", option.value);
                        } else {
                          setFieldValue("reason", "");
                        }
                      }}
                      placeholder="Select a reason"
                      className="mb-3"
                    />
                  </FormGroup>

                  {/* Remarks Field (Only if 'Other' is selected) */}
                  {values.otherSelected && (
                    <FormGroup>
                      <Label for="reason">Remarks <span style={{ color: "red" }}>*</span></Label>
                      <Field
                        as={Input}
                        type="textarea"
                        id="reason"
                        name="reason"
                        placeholder="Enter your reason..."
                        rows="4"
                        required
                        className={touched.reason && errors.reason ? "is-invalid" : ""}
                      />
                      <ErrorMessage name="reason" component="div" className="text-danger" />
                    </FormGroup>
                  )}

                  {/* Submit and Cancel Buttons */}
                  <div className='d-flex justify-content-end gap-3'>
                    <Button color="secondary" onClick={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }}>
                      Cancel
                    </Button>
                    <Button color="primary" type='submit'>
                      Submit
                    </Button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={showGenericConfirmationModal} toggle={() => { setShowGenericConfirmationModal(false); setSubmittedStatus("") }} backdrop="static">
        <ModalHeader toggle={() => { setShowGenericConfirmationModal(false); setSubmittedStatus("") }}>Confirm {selectedStatus?.label}</ModalHeader>
        <ModalBody>Are you sure you want to mark as {selectedStatus?.label}?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowGenericConfirmationModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handleGenericConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      {/* modal for generic submit */}
      <Modal isOpen={showGenericModal} toggle={() => { setShowGenericModal(false); setSubmittedStatus(""); setReason("") }} centered backdrop="static">
        <ModalHeader toggle={() => { setShowGenericModal(false); setSubmittedStatus(""); setReason("") }}>Provide a Reason</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center">
            <Formik
              initialValues={{ reason: "", otherSelected: false }}
              validationSchema={validationSchema2}
              onSubmit={handleGenericSubmit}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <FormikForm
                  className="px-4 mx-3 bg-white"
                  style={{ minWidth: "300px", width: "600px", maxWidth: "500px" }}
                >
                  {/* Reason Selection Dropdown */}
                  <FormGroup>
                    <Label for="reasonDropdown">Reason <span style={{ color: "red" }}>*</span></Label>
                    <Select
                      id="reasonDropdown"
                      options={[...reasonsList, { value: 'Other', label: 'Other' }]}
                      isLoading={isReasonsLoading}
                      onChange={(option) => {
                        setFieldValue("otherSelected", option.value === 'Other');
                        if (option.value !== 'Other') {
                          setFieldValue("reason", option.value);
                        } else {
                          setFieldValue("reason", "");
                        }
                      }}
                      placeholder="Select a reason"
                      className="mb-3"
                    />
                  </FormGroup>

                  {/* Remarks Field (Only if 'Other' is selected) */}
                  {values.otherSelected && (
                    <FormGroup>
                      <Label for="reason">Remarks <span style={{ color: "red" }}>*</span></Label>
                      <Field
                        as={Input}
                        type="textarea"
                        id="reason"
                        name="reason"
                        placeholder="Enter your reason..."
                        rows="4"
                        required
                        className={touched.reason && errors.reason ? "is-invalid" : ""}
                      />
                      <ErrorMessage name="reason" component="div" className="text-danger" />
                    </FormGroup>
                  )}

                  {/* Submit and Cancel Buttons */}
                  <div className='d-flex justify-content-end gap-3'>
                    <Button color="secondary" onClick={() => { setShowGenericModal(false); setSubmittedStatus(""); setReason("") }}>
                      Cancel
                    </Button>
                    <Button color="primary" type='submit'>
                      Submit
                    </Button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>


      {/* Mark as Complete Confirmation Modal */}
      {/* <Modal isOpen={showCompleteModal} toggle={() => { setShowCompleteModal(false); setSubmittedStatus("") }} centered backdrop="static">
        <ModalHeader toggle={() => setShowCompleteModal(false)}>Feedback Form</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center" >
            <Formik
              initialValues={{
                rating: 0,
                comment: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleFeedBackSubmit}
            >
              {({ setFieldValue, values, errors, touched }) => (
                <FormikForm
                  className="px-4  mx-3 bg-white"
                  style={{ minWidth: "300px", width: "600px", maxWidth: "500px" }}
                >
                  
                  <FormGroup>
                    <label className="">Rate Us</label>
                    <div className="d-flex align-items-center" >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((star, index) => (
                        <div className="" style={{ marginTop: "-26px", marginBottom: "-10px" }}>
                          <FaStar
                            key={star}
                            size={24}
                            className="me-1"
                            onClick={() => setFieldValue("rating", star)}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(null)}
                            color={star <= (hover || values.rating) ? "#ffc107" : "#e4e5e9"}
                            style={{ cursor: "pointer", marginTop: `${index === 0 ? "24px" : index === 9 ? "24px" : 0}` }}
                          />
                          <p>{index === 0 ? "Poor" : index === 9 ? "Excellent" : ''}</p>
                        </div>

                      ))}
                    </div>
                  </FormGroup>

                  
                  <FormGroup>
                    <Label for="comment">Comment</Label>
                    <Field
                      as={Input}
                      type="textarea"
                      id="comment"
                      name="comment"
                      placeholder="Leave your feedback here..."
                      rows="4"
                      className={touched.comment && errors.comment ? "is-invalid" : ""}
                    />
                    <ErrorMessage name="comment" component="div" className="text-danger" />
                  </FormGroup>

                  
                  <div className='d-flex justify-content-end gap-3'>
                    <Button color="secondary" onClick={() => { setShowCompleteModal(false); setSubmittedStatus(""); }}>
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      type='submit'
                    >
                      Upload
                    </Button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal> */}

      <InsertExtensionModal endDate={isExtend ? workOrderDetails?.scheduledEndDateTime : ''} visible={isExtend} handleClose={handleExtendClose} onExtendSubmit={handleExtendSubmit} />
      <div className="page-content px-4">
        <div className="d-flex justify-content-between align-items-center mx-2">
          <Breadcrumb title="Work Order Details" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Work Order Details", link: '#' }]} />
          <Button className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' onClick={() => navigate(`${location?.state?.path ? location?.state?.path : "/workorders"}`, { state: { cameFromWorkOrders: true } })}>
            Back
          </Button>
        </div>
        {!loading && <div>
          <Row>
            {/* Buttons */}
            <Col sm="12" md="12" lg="12" className="text-end mb-4">
              {statusList?.length > 0 && <div className='d-inline-block me-2'>
                <div className='d-flex gap-2 align-items-center'>
                  <Select
                    options={statusList?.map(item => ({ label: item?.stateName, value: item?.stateName }))}
                    value={selectedStatus}
                    isLoading={isStatusLoading}
                    onChange={setSelectedStatus}
                    placeholder="Select Status"
                    isClearable={true}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        textAlign: "left",
                        width: "233px",
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }),
                      input: (provided) => ({
                        ...provided,
                        width: "200px",
                        paddingLeft: "0px !important",
                        paddingRight: "0px !important",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        textAlign: "left",
                      }),
                      menuList: (provided) => ({
                        ...provided,
                        textAlign: "left",
                      }),
                    }} />
                  <Button onClick={() => { if (selectedStatus && selectedStatus) setSubmittedStatus(selectedStatus.value?.split(" ").join("")); }}>submit</Button>
                </div>
              </div>}
              {<Button color="primary" className="me-2" title="take print" onClick={handlePrint}>Print</Button>}
              {(workOrderDetails?.isFeedbackbtnVisible === 1) && <Button color="primary" className="me-2" title="Copy Feedback Link" onClick={handleCopy}><IoCopyOutline color='white' /></Button>}
              {((workOrderDetails?.isFeedbackbtnVisible === 1) && permissions2?.map(item => item?.permissionName)?.includes("Feedback Link")) && <Button color="primary" className="me-2" >Feedback Link</Button>}
              {((workOrderDetails?.isEditbtnVisib === 1) && permissions2?.map(item => item?.permissionName)?.includes("Edit Work Orders")) && <Button color="primary" className="me-2" onClick={() => navigate(`/editWorkOrder/${id}`)}>Edit</Button>}
              {((workOrderDetails?.isExtendbtnVisib === 1) && permissions2?.map(item => item?.permissionName)?.includes("Work Order Extension")) && <Button color="secondary" className="me-2" onClick={() => setIsExtend(true)}>Extent</Button>}
            </Col>
          </Row>

          <Row>
            {/* Work Order Number & Status */}
            <Col xs="6" md="6" lg="6">
              <h4>#{workOrderDetails?.workOrderNumber}</h4>
            </Col>
            <Col xs="6" md="6" lg="6" className="text-end">
              <h6 className='text-end p-1 px-3 d-inline rounded-pill bg-secondary' style={{ border: "1px solid lightgray" }}>{workOrderDetails?.workOrderStatus
                ?.replace(/workorder /i, "work order ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}</h6>
            </Col>
          </Row>

          <Row>
            <Col sm="12" >
              <Card className="mb-4" >
                <CardBody >
                  <Row>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Start Date:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(workOrderDetails?.scheduledStartDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>End Date:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(workOrderDetails?.scheduledEndDateTime) || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <RiTeamLine size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Team:</h6>
                            <p className='m-0'>{workOrderDetails?.teamName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaUserCircle size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Comment:</h6>
                            <p className='m-0'>{workOrderDetails?.agentComments || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          < FaUser size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }} >Employee Name</h6>
                            <p className='m-0'>{workOrderDetails?.userName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaCodeBranch size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Branch</h6>
                            <p className='m-0'> {workOrderDetails?.branchName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaHashtag size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Empoyeee Id</h6>
                            <p className='m-0'>{workOrderDetails?.employeeId || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Created At:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(workOrderDetails?.createdAt) || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    {workOrderDetails?.statusChangeReason && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <LiaComment size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Remarks:</h6>
                            <p className='m-0'>{workOrderDetails?.statusChangeReason || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                    {workOrderDetails?.sabelUserId && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <LuSquareUserRound size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>SebelUserId:</h6>
                            <p className='m-0'>{workOrderDetails?.SabelUserIdName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                    {workOrderDetails?.remedyNumber && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <IoTicketOutline size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Remedy Number:</h6>
                            <p className='m-0'>{workOrderDetails?.remedyNumber || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                    {workOrderDetails?.solutionName && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <AiOutlineSolution size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Solution:</h6>
                            <p className='m-0'>{workOrderDetails?.solutionName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                  </Row>
                  {/* <ListGroupItem><strong>Created At:</strong> {createdAt}</ListGroupItem> */}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Customer Information & Address Information */}
            <Col sm="12" md="6" lg="6">
              <Card className="mb-4">
                <CardBody>
                  <div className='d-flex justify-content-between align-items-center' >
                    <h5 className='fw-bold'>Customer Information</h5>
                    <Link to={workOrderDetails?.customerInvoicePath ? `${process.env.REACT_APP_BASE_URL + workOrderDetails?.customerInvoicePath}` : "#"} target={workOrderDetails?.customerInvoicePath ? "_blank" : "_self"}><button className='btn btn-primary'>Customer Invoice</button></Link>
                  </div>
                  <div className='pt-2 mt-3'>
                    <p>{customerProfile?.customerNameEng} ({customerProfile?.customerNameAr})</p>
                    <p><strong>Contact:</strong> {customerProfile?.contactNumber1} , {customerProfile?.contactNumber2}</p>
                    <p><strong>Contract Number:</strong> {customerProfile?.contractNumber}</p>
                    <p><strong>Contract Id:</strong> {customerProfile?.contractId}</p>
                    <p><strong>Subscriber Number:</strong> {customerProfile?.subscriberNumber}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm="12" md="6" lg="6" >
              <Card className="mb-4">
                <CardBody style={{ minHeight: "297px" }}>
                  <h5>Address Information</h5>
                  <div className='pt-2 mt-3'>
                    <p> {addresses?.addressLine}</p>
                    <p> {addresses?.area}</p>
                    <p> {addresses?.areaDescription}</p>
                    <p> {addresses?.landMark}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Work Order Items Table */}
          <Row>
            <Col sm="12" md="12" lg="12">
              <Card className="mb-4" >
                <CardBody >
                  <h5>Work Order Items</h5>
                  <Table >
                    <thead>
                      <tr>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Image</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Item</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Department</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Time per Item</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Serial Number</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Quantity</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workOrderItems?.map((item, index) => (
                        <tr key={index}>
                          <td className='border-1'>{<img src={`${process.env.REACT_APP_BASE_URL}${item?.image}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />}</td>
                          <td className='border-1'><span>{item.catalogueItem}</span><br /><span>{`(${item?.model}, ${item?.sku})`}</span></td>
                          <td className="border-1">{item?.departmentName}</td>
                          <td className='border-1'>{(() => {
                            const totalMinutes = item?.estimatedInstallTimeInMins; // Total time in minutes
                            const hours = Math.floor(totalMinutes / 60); // Calculate hours
                            const minutes = totalMinutes % 60; // Calculate remaining minutes

                            return hours > 0
                              ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                              : `${minutes} min${minutes > 1 ? 's' : ''}`;
                          })()}</td>
                          <td className='border-1'>{item?.serialNumber || 'N/A'}</td>
                          <td className='border-1'>{item.quantity}</td>
                          <td>{(() => {
                            const totalMinutes = item?.estimatedInstallTimeInMins * item?.quantity; // Total time in minutes
                            const hours = Math.floor(totalMinutes / 60); // Calculate hours
                            const minutes = totalMinutes % 60; // Calculate remaining minutes

                            return hours > 0
                              ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                              : `${minutes} min${minutes > 1 ? 's' : ''}`;
                          })()}</td>
                        </tr>
                      ))}
                      {workOrderItems?.length <= 0 && <tr>
                        <td colSpan='3' className='text-center'>No Items found</td>
                      </tr>}
                    </tbody>
                  </Table>
                  <h5 className='text-end'><strong>Total Time:</strong>{(() => {
                    const totalMinutes = workOrderItems?.reduce((sum, item) => {
                      return sum + (item?.estimatedInstallTimeInMins * item?.quantity);
                    }, 0);

                    const hours = Math.floor(totalMinutes / 60); // Calculate hours
                    const minutes = totalMinutes % 60; // Calculate remaining minutes

                    return hours > 0
                      ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                      : `${minutes} min${minutes > 1 ? 's' : ''}`;
                  })()}</h5>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {imagePreviews?.length > 0 && <div >
            <h5>Location Images</h5>
            <Row>
              {imagePreviews.map((preview, index) => (
                <Col key={index} xs="12" md="4" className="mb-3 position-relative">
                  <div
                    className="image-preview-container"
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      width: '100%',
                      height: 'auto',
                    }}
                  >
                    <img
                      src={preview}
                      alt={`preview-${index}`}
                      style={{
                        width: '100%',
                        height: '200px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>}
        </div>}
        <div style={{ display: "none" }} ref={printRef}>
          <div className='d-flex justify-content-center align-items-center'><img src={LOGO_IMG} /></div>
          <h5>WORKORDER FORM :#{workOrderDetails?.workOrderNumber}</h5>
          <Row>
            <Col sm="12" >
              <Card className="mb-4" >
                <CardBody >
                  <Row>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Start Date:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(workOrderDetails?.scheduledStartDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>End Date:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(workOrderDetails?.scheduledEndDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <RiTeamLine size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Team:</h6>
                            <p className='ms-1'>{workOrderDetails?.teamName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaUserCircle size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Comment:</h6>
                            <p className='ms-1'>{workOrderDetails?.agentComments || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          < FaUser size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }} >Employee Name</h6>
                            <p className='ms-1'>{workOrderDetails?.userName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaCodeBranch size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Branch</h6>
                            <p className='ms-1'>{workOrderDetails?.branchName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaHashtag size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Empoyeee Id</h6>
                            <p className='ms-1'>{workOrderDetails?.employeeId}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Created At:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(workOrderDetails?.createdAt)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* <ListGroupItem><strong>Created At:</strong> {createdAt}</ListGroupItem> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {/* Customer Information & Address Information */}
            <Col xs="6" md="6" lg="6">
              <Card className="mb-2">
                <CardBody>
                  <div className='d-flex justify-content-between align-items-center' >
                    <h5 className='fw-bold'>Customer Information</h5>
                  </div>
                  <div className='pt-2 mt-3'>
                    <p>{customerProfile?.customerNameEng} ({customerProfile?.customerNameAr})</p>
                    <p><strong>Contact:</strong> {customerProfile?.contactNumber1} , {customerProfile?.contactNumber2}</p>
                    <p><strong>Contract Number:</strong> {customerProfile?.contractNumber}</p>
                    <p><strong>ContractId:</strong> {customerProfile?.contractId}</p>
                    <p><strong>Subscriber Number:</strong> {customerProfile?.subscriberNumber}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xs="6" md="6" lg="6" >
              <Card className="mb-2">
                <CardBody style={{ minHeight: "297px" }}>
                  <h5>Address Information</h5>
                  <div className='pt-2 mt-3'>
                    <p> {addresses?.addressLine}</p>
                    <p> {addresses?.area}</p>
                    <p> {addresses?.areaDescription}</p>
                    <p> {addresses?.landMark}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="12" lg="12">
              <Card className="mb-2" >
                <CardBody >
                  <h5>Work Order Items</h5>
                  <Table >
                    <thead>
                      <tr >
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Item</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Quantity</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Department</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Serial Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workOrderItems?.map((item, index) => (
                        <tr key={index}>
                          <td className='border-1'><span>{item.catalogueItem}</span><br /><span>{`(${item?.model}, ${item?.sku})`}</span></td>
                          <td className='border-1'>{item.quantity}</td>
                          <td className="border-1">{item?.departmentName}</td>
                          <td className="border-1">{item?.serialNumber || "N/A"}</td>
                        </tr>
                      ))}
                      {workOrderItems?.length <= 0 && <tr>
                        <td colSpan='3' className='text-center'>No Items found</td>
                      </tr>}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className='terms-and-conditions-print'>
            <h5>Terms And Conditions</h5>
            <ul>
              <li>This package does not include the Cat 6 Ethernet cable / Piping required to connect the cameras to the NVR, nor does it include the hard drive needed to store recorded footage. Hard drive costs vary based on capacity (typically ranging from 20 K.D. to 90 K.D.). These components must be purchased separately according to the customer’s needs.</li>
              <li>This package does not include any additional accessories that are not essential for the basic operation of the camera and NVR system, such as an LCD screen. These optional items may be purchased separately, at the customer’s discretion and expense.</li>
            </ul>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ minHeight: "120px" }}>
            <div className='' style={{ borderTop: "1px solid lightgray" }}>
              <h6 style={{ marginTop: "60px" }}>Customer Sign</h6>
            </div>
            <div className="" style={{ borderTop: "1px solid lightgray" }}>
              <h6 style={{ marginTop: "60px" }}>Sales Agent Sign</h6>
            </div>
          </div>
        </div>
        {loading && <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "400px" }}>
          <FadeLoader color="#007bff" size={35} />
        </div>}
      </div>
    </>

  );
};

export default WorkOrderDetails;
